import { type FileUploadResponseItem } from '@atlassian/conversation-assistant-service';
import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Properties for the rovo inline input box send message command.
 *
 * @extends CommandProperties
 */
export interface InlineInputBoxSendMessageCommandProperties extends CommandProperties {
	prompt: string;
	source: string;
	productKey: string;
	deepResearchEnabled: boolean;
	webSearchEnabled: boolean;
	appFilters?: string[];
	files?: FileUploadResponseItem[];
}

/**
 * A command sent by the rovo inline input box client to send a message to rovo chat.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to send a message to the input prompt box.
 */
export const InlineInputBoxSendMessageCommand =
	createCommand<InlineInputBoxSendMessageCommandProperties>(
		'inline-input-box-send-message-command',
	);
